import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasCategoryContext, withCategory } from "@insite/client-framework/Components/CategoryContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCategoryState } from "@insite/client-framework/Store/Data/Categories/CategoriesSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button from "@insite/mobius/Button";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Icon from "@insite/mobius/Icon";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import AlertMessageIcon from "@tCentro/Icons/AlertMessageIcon";
import { COLORS, TYPOGRAPHY } from "@tCentro/theme/design";
import parse from "html-react-parser";
import truncate from "lodash/truncate";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

import transformContentHtml from "@insite/client-framework/Common/Utilities/transformContentHtml";
import AlertTriangle from "@insite/mobius/Icons/AlertTriangle";
import getProp from "@insite/mobius/utilities/getProp";

const enum fields {
    showImages = "showImages",
}

interface Props extends WidgetProps, HasCategoryContext {}

export interface CategoryDetailSubCategoriesStyles {
    container?: GridContainerProps;
    subCategoryItem?: GridItemProps;
    subCategoryImageClickable?: ClickablePresentationProps;
    subCategoryImage?: LazyImageProps;
    subCategoryNameLink?: LinkPresentationProps;
    mobileDefaultIconWrapper?: InjectableCss;
    cardWrapper?: InjectableCss;
    subCategoryNameWrapper?: InjectableCss;
    mobileCloseIconWrapper?: InjectableCss;
    hoveredLink?: InjectableCss;
    subCategoryhoveredName?: InjectableCss;
    hoveredCategoryNameWrapper?: InjectableCss;
    defaultProductImage?: InjectableCss;
    subCategoryhoveredDesc?: InjectableCss;
    MainContainer?: InjectableCss;
}

export const categoryDetailSubCategoriesStyles: CategoryDetailSubCategoriesStyles = {
    hoveredCategoryNameWrapper: {
        css: css`
            padding: 40px;
            display: flex;
            flex-direction: column;
            @media (min-width: 992px) and (max-width: 1200px) {
                padding: 10px;
                text-align: left;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        /* padding: 40px 40px 0; */
                        text-align: left;
                    `,
                    css`
                        /* padding: 40px 40px 0; */
                        text-align: left;
                    `,
                    css`
                        padding: 40px;
                        text-align: left;
                    `,
                    null,
                ])}
        `,
    },
    subCategoryhoveredName: {
        css: css`
            font-weight: ${TYPOGRAPHY.weight.mediumbold};
            font-size: ${TYPOGRAPHY.size.large};
            line-height: 24px;
            color: ${getProp("theme.typography.p.color")};
            padding-bottom: 8px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                ])}
        `,
    },
    hoveredLink: {
        css: css`
            font-weight: ${TYPOGRAPHY.weight.mediumbold};
            font-size: ${TYPOGRAPHY.size.smaller};
            line-height: 16px;
            color: ${COLORS.link.base};
        `,
    },
    cardWrapper: {
        css: css`
            width: 100%;
        `,
    },
    subCategoryNameWrapper: {
        css: css`
            width: 100%;
            padding: 32px;
            background: ${COLORS.background.grayShade};
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 32px 32px 0;
                    `,
                    css`
                        padding: 32px 32px 0;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    container: {
        gap: 0,
        css: css`
            margin-bottom: 104px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-bottom: 56px;
                    `,
                    css`
                        margin-bottom: 78px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    subCategoryItem: {
        width: [12, 12, 6, 3, 3],
        css: css`
            padding: 0 12px;
            margin-top: 20px !important;

            @media (min-width: 992px) {
                &:hover {
                    .defaultCard {
                        display: none;
                    }

                    .hoveredCard {
                        box-shadow: 0px 8px 16px rgba(38, 37, 37, 0.24);
                        display: block;
                        min-height: 336px !important;
                    }
                }
            }
            @media (min-width: 768px) and (max-width: 991px) {
                &:nth-child(n + 4) {
                    margin-top: 24px !important;
                }
            }

            > div {
                background: ${COLORS.background.grayShade};
                min-height: 299px !important;
                width: 100%;
            }
            .hoveredCard {
                display: none;
                transition: all 0.2s ease-in-out;
            }

            &.hoverEffect .hoveredCard {
                display: flex;
                width: 100%;
                flex-basis: 100%;
                flex-direction: column;
                box-shadow: 0px 8px 16px rgba(38, 37, 37, 0.24);
                background: ${COLORS.background.grayShade};
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            max-height: 256px;
                        `,
                        css`
                            max-height: 275px;
                        `,
                        null,
                        null,
                    ])}
            }
            &.hoverEffect .defaultCard {
                display: none;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 0;
                        margin-bottom: 24px !important;
                    `,
                    css`
                        padding: 0;
                        margin-bottom: 24px !important;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    subCategoryImageClickable: {
        css: css`
            width: 100%;

            > div {
                width: 100%;
            }
        `,
    },
    subCategoryImage: {
        css: css`
            img {
                height: auto;
                max-height: 163px;
                width: 100%;
                aspect-ratio: 1 / 1;
                object-fit: initial;
            }
        `,
    },
    subCategoryNameLink: {
        css: css`
            width: 100%;
        `,
        color: "text.main",
        typographyProps: {
            size: TYPOGRAPHY.size.tiny,
            weight: TYPOGRAPHY.weight.mediumbold,
            css: css`
                line-height: 24px;
                width: 100%;
                word-wrap: break-word;
                color: ${getProp("theme.typography.p.color")} !important;
                font-size: ${TYPOGRAPHY.size.small};
            `,
        },
    },
    mobileDefaultIconWrapper: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: block;
                        position: absolute;
                        right: 25px;
                    `,
                    css`
                        display: block;
                        position: absolute;
                        right: 25px;
                    `,
                    css`
                        display: block;
                        position: absolute;
                        right: 25px;
                        bottom: 0;
                    `,
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                ])}
        `,
    },
    mobileCloseIconWrapper: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: block;
                        position: absolute;
                        right: 25px;
                        bottom: 25px;
                    `,
                    css`
                        display: block;
                        position: absolute;
                        right: 25px;
                        bottom: 25px;
                    `,
                    css`
                        display: block;
                        position: absolute;
                        right: 25px;
                        bottom: 25px;
                    `,
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                ])}
        `,
    },
    defaultProductImage: {
        css: css`
            [class^="LazyImageStyle-sc"] {
                width: 100%;
            }
            background: ${COLORS.white};
            justify-content: center;
            img {
                width: 100%;
                max-height: 163px;
                object-fit: contain;
                height: auto;
                aspect-ratio: 1/1;
            }
        `,
    },
    subCategoryhoveredDesc: {
        css: css`
            margin-bottom: 16px;
            p {
                font-size: ${TYPOGRAPHY.size.smaller} !important;
                font-weight: ${TYPOGRAPHY.weight.base};
                line-height: ${TYPOGRAPHY.lineHeight.base};
                font-family: "Poppins" !important;
                color: ${getProp("theme.typography.p.color")};
            }
            html body {
                background: transparent;
                font-size: ${TYPOGRAPHY.size.smaller} !important;
                font-weight: ${TYPOGRAPHY.weight.base};
                line-height: ${TYPOGRAPHY.lineHeight.base};
                font-family: "Poppins" !important;
                color: ${getProp("theme.typography.p.color")};
                p {
                    font-size: ${TYPOGRAPHY.size.smaller} !important;
                    font-weight: ${TYPOGRAPHY.weight.base};
                    line-height: ${TYPOGRAPHY.lineHeight.base};
                    font-family: "Poppins" !important;
                    color: ${getProp("theme.typography.p.color")};
                }
            }
        `,
    },
    MainContainer: {
        css: css`
            perspective: 1000px;
            position: relative;
            &.defaultCard {
                min-height: 336px !important;
                position: absolute;
                top: 0;
                left: 0;
                backface-visibility: hidden;
                transform-style: preserve-3d;
                transition: all 0.5s ease;
            }
            &.card.flipped .back {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-color: #f2f2f2;
                display: flex;
                justify-content: center;
                align-items: center;
                text-align: center;
            }
            &.defaultCard {
                transform: rotateY(180deg);
            }
            &.card.flipped {
                transform: rotateY(180deg);
            }
            &.card.flipped .back {
                transform: rotateY(180deg);
            }
        `,
    },
};

const styles = categoryDetailSubCategoriesStyles;

const CategoryDetailSubCategories = ({ category, fields: { showImages } }: Props) => {
    if (!category || !category.subCategoryIds || category.subCategoryIds.length === 0) {
        return null;
    }

    return (
        <GridContainer {...styles.container}>
            {category.subCategoryIds.map(subCategoryId => (
                <GridItem key={subCategoryId} {...styles.subCategoryItem} id={`mobileContainer${subCategoryId}`}>
                    <SubCategoryLink categoryId={subCategoryId} showImages={showImages} />
                </GridItem>
            ))}
        </GridContainer>
    );
};

const SubCategoryLinkView = ({
    category,
    showImages,
}: ReturnType<typeof mapStateToProps> & { showImages: boolean }) => {
    if (!category) {
        return null;
    }

    const [flipped, setFlipped] = React.useState(false);

    const handleClick = () => {
        setFlipped(!flipped);
    };

    return (
        <>
            <StyledWrapper {...styles.MainContainer} className={flipped ? "card flipped" : "card"}>
                <StyledWrapper {...styles.cardWrapper} className="defaultCard ">
                    {showImages && category.smallImagePath ? (
                        <Clickable href={category.path} {...styles.subCategoryImageClickable}>
                            <LazyImage
                                src={category.smallImagePath}
                                altText={category.imageAltText}
                                {...styles.subCategoryImage}
                            />
                        </Clickable>
                    ) : (
                        <Clickable
                            href={category.path}
                            data-test-selector="productImage"
                            {...styles.defaultProductImage}
                        >
                            <LazyImage
                                src="/userFiles/images/default-product-image.png"
                                altText="Default product image"
                            />
                        </Clickable>
                    )}

                    <StyledWrapper {...styles.subCategoryNameWrapper}>
                        <Link
                            href={category.path}
                            {...styles.subCategoryNameLink}
                            data-test-selector={`categoryDetailsSubCategoriesLink_${category.id}`}
                        >
                            {category.shortDescription}
                        </Link>
                    </StyledWrapper>
                    <StyledWrapper
                        data-test-selector="mobile-hover-icons"
                        {...styles.mobileDefaultIconWrapper}
                        onClick={handleClick}
                    >
                        <LazyImage src="/UserFiles/Images/mobile-i-icon.png" className="defaultMobileIcon" />
                    </StyledWrapper>
                </StyledWrapper>
                <StyledWrapper {...styles.cardWrapper} className="hoveredCard back">
                    <StyledWrapper className="back-content">
                        <StyledWrapper {...styles.hoveredCategoryNameWrapper}>
                            <Typography {...styles.subCategoryhoveredName}>{category.shortDescription}</Typography>
                            {category.htmlContent && (
                                <StyledWrapper {...styles.subCategoryhoveredDesc}>
                                    {parse(
                                        transformContentHtml(truncate(category.htmlContent, { length: 250 })),
                                        parserOptions,
                                    )}
                                </StyledWrapper>
                            )}

                            <Link
                                href={category.path}
                                {...styles.hoveredLink}
                                data-test-selector={`categoryDetailsSubCategoriesLink_${category.id}`}
                            >
                                {translate("Shop Products")}
                            </Link>
                        </StyledWrapper>
                        <StyledWrapper
                            data-test-selector="mobile-hover-icons"
                            {...styles.mobileCloseIconWrapper}
                            onClick={handleClick}
                        >
                            <LazyImage src="/UserFiles/Images/mobile-close-icon.png" className="hoverMobileIcon" />
                        </StyledWrapper>
                    </StyledWrapper>
                </StyledWrapper>
            </StyledWrapper>
        </>
    );
};

const mapStateToProps = (state: ApplicationState, ownProps: { categoryId: string }) => ({
    category: getCategoryState(state, ownProps.categoryId).value,
});

const SubCategoryLink = connect(mapStateToProps)(SubCategoryLinkView);

const widgetModule: WidgetModule = {
    component: withCategory(CategoryDetailSubCategories),
    definition: {
        group: "Category Details",
        icon: "list-ul",
        fieldDefinitions: [
            {
                name: fields.showImages,
                displayName: "Show Images",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                sortOrder: 1,
            },
        ],
        allowedContexts: ["CategoryDetailsPage"],
    },
};

export default widgetModule;
